/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SearchInvoiceLinesQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.InvoicelineSearch>;
  pagination: Types.Pagination;
}>;


export type SearchInvoiceLinesQuery = {
  __typename?: 'Query',
  searchInvoicelines?: {
    __typename?: 'InvoicelinePage',
    totalElements?: number | null,
    content?: Array<{
      __typename?: 'InvoiceLine',
      id: number,
      description?: string | null,
      weekNumber?: number | null,
      quantity?: number | null,
      unit?: string | null,
      unexpected?: boolean | null,
      invoiceReference?: string | null,
      approved?: boolean | null,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      price?: {
        __typename?: 'Price',
        value?: number | null,
        currency?: {
          __typename?: 'Currency',
          isoCode?: string | null,
          symbol?: string | null
        } | null
      } | null,
      vatCode?: {
        __typename?: 'VATCode',
        id: number,
        label?: string | null
      } | null,
      agreement?: {
        __typename?: 'AddressCommissionAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'BlockFreightAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'BunkerAdjustmentAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'CleaningAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'CommissionAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DailyAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DangerousGoodAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DeadfreightAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DemurrageAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DemurrageCalculationAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'FeetAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'FreightAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'GasolineAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'GasolinePriceAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'HoseRentalAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'HourlyAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'LumpsumAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'MultiCargoAdjustmentAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'MultiOrderAdjustmentAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'NitrogenPurgingAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'OogAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'PJKAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'PostCalculationAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ReeferAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'RentAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ReturnFreightDiscountAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ShipAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'SupplementaryHeatingAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'TeuAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'TextAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WaterLevelAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WaterwayAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WeightAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WeightRangeAgreement',
        type: Types.AgreementTypeEnum,
        summary?: string | null,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | null,
      costType?: {
        __typename?: 'CostType',
        id: number,
        title_en?: string | null,
        title_nl?: string | null,
        title_de?: string | null
      } | null,
      charter?: {
        __typename?: 'PurchaseCharter',
        id: number,
        charterNumber: string,
        type: Types.CharterType,
        contract?: {
          __typename?: 'Contract',
          id: number,
          contractNumber?: string | null
        } | null
      } | {
        __typename?: 'SalesCharter',
        id: number,
        charterNumber: string,
        type: Types.CharterType,
        contract?: {
          __typename?: 'Contract',
          id: number,
          contractNumber?: string | null
        } | null
      } | null,
      ship?: {
        __typename?: 'Ship',
        id: number,
        name: string
      } | null
    }> | null
  } | null
};


export const SearchInvoiceLinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchInvoiceLines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicelineSearch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchInvoicelines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weekNumber"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCode"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"vatCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"calculationMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"costType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_nl"}},{"kind":"Field","name":{"kind":"Name","value":"title_de"}}]}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unexpected"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceReference"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}}]}}]}}]}}]} as unknown as DocumentNode<SearchInvoiceLinesQuery, SearchInvoiceLinesQueryVariables>;